export default __webpack_public_path__ + "static/media/24.2ff092f5.png";